module.exports = __webpack_public_path__ + "static/media/logos_squares_Diamond_ATAL.56590305.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Diamond_ATAL.png
// module id = 75
// module chunks = 0